import { render, staticRenderFns } from "./AppToast.vue?vue&type=template&id=b5fa3800&scoped=true"
import script from "./AppToast.vue?vue&type=script&lang=js"
export * from "./AppToast.vue?vue&type=script&lang=js"
import style0 from "./AppToast.vue?vue&type=style&index=0&id=b5fa3800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fa3800",
  null
  
)

export default component.exports